import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { handleAuthorization } from './authorization.middleware';
import { handleAnalytics } from './analytics.middleware';

import { isActiveReduxLogger } from '../../config/dev.config';

// NOT: handleAuthenticated middleware'i kaldırıldı. 401'de token refresh +
// isteği yeniden deneme artık services/http.service.js interceptor'ında
// yapılıyor. Eski middleware *_REJECTED aksiyonlarını reducer'lara
// iletmediği için loading state'leri asılı kalıyor ve token süresi
// dolduğunda ekran beyaz kalıyordu.
const MIDDLEWARES = [
  thunk,
  handleAuthorization,
  handleAnalytics,
];

if (process.env.NODE_ENV === "development") {
  isActiveReduxLogger && MIDDLEWARES.push(createLogger({}));
}

export const Middlewares = {
  get() {
    return MIDDLEWARES;
  },
};
